import React from "react";
import ReactModal from "react-modal";
import { browserVersion, isMobile } from "react-device-detect";

import { LoadingOverlay } from "../../components";
import {
  AssignSellRequests,
  Commissions,
  InternalDetailsAndCosts,
  Invoice,
  Payments,
  PxSummary,
  SelectListings,
  TrackingNumber,
} from "../molecules";
import { useOrderManagement } from "../useOrderManagement";

import "./order-flow.scss";

export function OrderFlow() {
  const {
    onClose,
    step,
    lastStep,
    submitting,
    isPxOrder,
    flowModalOpen,
    client,
    listings,
    sellRequests,
    quotes,
    setQuotes,
    deposits,
    updateDepositField,
    removeDepositRow,
    taxRates,
    updateTaxRate,
    totalRemainingPaid,
    setTotalRemainingPaidField,
    paidAmount,
    populatedAmount,
    toPay,
    sellRequestsAmount,
    showPaymentErrors,
    arePaymentsValid,
    onRemoveSellRequest,
    proceedToPayment,
    savePayments,
    goToInvoice,
    getPdf,
    getPdfUrl,
    paymentDialog,
    updatePaymentDialog,
    goToSummary,
    goToCommissions,
    items,
    commissions,
    updateCommissionField,
    addCommissionSlot,
    removeCommissionSlot,
    itemProfit,
    saveCommissions,
    commissionsAmount,
    commissionFees,
    netProfitBeforeCommissions,
    skipSellRequests,
    costsCurrentListingIdx,
    fees,
    marketplaceFee,
    setMarketplaceFee,
    marketplaceFeeType,
    setMarketplaceFeeType,
    orderPaid,
    allPaymentsConfirmed,
    saveCosts,
    finaliseCosts,
    trackingNumber,
    setTrackingNumber,
    saveTrackingNumber,
    order_id,
    initToggleStatus,
    existUserCompany,
  } = useOrderManagement();
  return (
    <ReactModal
      {...{
        isOpen: flowModalOpen,
        onRequestClose: onClose,
        className: `product-preview-modal ${
          browserVersion < 15 && !isMobile
            ? "old-mac-product-preview-modal"
            : ""
        }`,
      }}
    >
      <>
        <div className="close-modal">
          <img src="/assets/icons/cancel-black.svg" onClick={onClose} />
        </div>

        <div className="order-management-flow">
          <SelectListings listings={listings} />

          <AssignSellRequests
            {...{
              step,
              lastStep,
              isPxOrder,
              client,
              sellRequests,
              skipSellRequests,
              goToSummary,
            }}
          />

          <PxSummary
            {...{
              step,
              lastStep,
              client,
              listings,
              sellRequests,
              quotes,
              setQuotes,
              isPxOrder,
              onRemoveSellRequest,
              proceedToPayment,
            }}
          />

          <Payments
            {...{
              step,
              lastStep,
              isPxOrder,
              client,
              listings,
              sellRequests,
              quotes,
              deposits,
              updateDepositField,
              removeDepositRow,
              taxRates,
              updateTaxRate,
              totalRemainingPaid,
              showPaymentErrors,
              setTotalRemainingPaidField,
              arePaymentsValid,
              savePayments,
              goToInvoice,
              paymentDialog,
              updatePaymentDialog,
              paidAmount,
              populatedAmount,
              toPay,
              orderPaid,
              fees,
              sellRequestsAmount,
              allPaymentsConfirmed,
              marketplaceFee,
              setMarketplaceFee,
              marketplaceFeeType,
              setMarketplaceFeeType,
            }}
          />

          <Invoice
            {...{
              step,
              order_id,
              getPdf,
              getPdfUrl,
              lastStep,
              goToCommissions,
              initToggleStatus,
              existUserCompany,
            }}
          />

          <Commissions
            {...{
              step,
              lastStep,
              commissions,
              updateCommissionField,
              addCommissionSlot,
              removeCommissionSlot,
              itemProfit,
              saveCommissions,
              items,
              netProfitBeforeCommissions,
              commissionsAmount,
              isPxOrder,
            }}
          />

          {listings.map((listing, idx) => {
            if (idx > costsCurrentListingIdx) {
              return null;
            }

            return (
              <InternalDetailsAndCosts
                {...{
                  key: listing.id,
                  order_id: items && items[0]?.order_id,
                  step,
                  lastStep,
                  listings,
                  fees,
                  commissionsAmount,
                  commissionFees,
                  marketplaceFee,
                  setMarketplaceFee,
                  idx,
                  costsCurrentListingIdx,
                  saveCosts,
                  finaliseCosts,
                }}
              />
            );
          })}

          <TrackingNumber
            {...{
              step,
              lastStep,
              isPxOrder,
              paidAmount,
              trackingNumber,
              setTrackingNumber,
              saveTrackingNumber,
            }}
          />
        </div>

        {submitting && (
          <LoadingOverlay type="submitting" text="Saving order..." />
        )}
      </>
    </ReactModal>
  );
}
